import api from '@/api/device';
import store from '@/store';

const setDeviceName = (context, token) => {
  context.commit('SET_DEVICE_NAME', token);
};

const setDeviceToken = (context, token) => {
  context.commit('SET_DEVICE_TOKEN', token);
};

const deleteDevice = context => new Promise(((resolve, reject) => {
  const token = { deviceToken: store.getters['device/deviceToken'] };
  if (token.deviceToken === '' || token.deviceToken === undefined) {
    resolve();
  } else {
    api.deleteDevice(token)
      .then((response) => {
        context.commit('DESTROY_DEVICE');
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  }
}));


export default {
  setDeviceName,
  setDeviceToken,
  deleteDevice
};



// WEBPACK FOOTER //
// ./src/store/modules/device/actions.js